import React from 'react';

import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface StarterSystemCardProps {
  image: string; // Main post image or video url
  media_type?: string; // 'IMAGE' or 'VIDEO'
  title: string; // Used as username
  description: string; // Used as caption
  url?: string; // The URL to open on icon click
  tagRemoved?: boolean;
  
}

const StarterSystemCard: React.FC<StarterSystemCardProps> = ({ image, media_type, title, description, url, tagRemoved }) => (
  <div
    style={{
      width: 340,
      height: 420,  
      background: '#fff',
      border: '1.5px solid #e5d9fa',
      borderRadius: 18,
      padding: 0,
      boxShadow: '0 2px 8px 0 rgba(80, 80, 140, 0.10)',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      fontFamily: 'Inter, system-ui, sans-serif',
      overflow: 'hidden',
      position: 'relative',
    }}
  >
    {/* Header */}
    <div style={{ display: 'flex', alignItems: 'center', padding: '14px 18px 10px 18px' }}>
      {/* Optionally render a brand/account logo here if you have it in your data */}
      <div style={{ flex: 1 }}>
       
        {!tagRemoved && (
          <>
          {title && (
            <div style={{ fontWeight: 600, fontSize: 15 }}>
              # {title}
            </div>
          )}
          
          </>
        )}
      </div>
      {url && (
        <IconButton
          aria-label="open in new tab"
          onClick={e => { e.stopPropagation(); window.open(url, '_blank', 'noopener,noreferrer'); }}
          size="small"
          style={{ marginLeft: 8 }}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      )}
    </div>

    {/* Main Image */}
    {(image && media_type === 'VIDEO') && (
      <div style={{ background: '#eee', width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <video
          src={image}
          controls
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 0 }}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    )}
    {(image && (!media_type || media_type === 'IMAGE' || media_type === 'CAROUSEL_ALBUM')) && (
      <div style={{ background: '#eee', width: '100%', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <img
          src={image}
          alt="post"
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 0 }}
        />
      </div>
    )}
    {/* If no image/video, show nothing */}



    {/* Meta (caption/description) */}
    {(title || description) && (
      <div style={{ padding: '7px 18px 0 18px', fontSize: 14, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {title && (
          <div style={{ fontWeight: 500, marginBottom: 6 }}>{title}</div>
        )}
        {description && (
          <div style={{ fontSize: 15, color: '#222', overflow: 'auto', flex: 1 }}>{description}</div>
        )}
      </div>
    )}
  </div>
);

export default StarterSystemCard;
